import {Injectable} from "@angular/core";
import {
    NotifyDownloadAppMessageViewedUseCase
} from "@app/core/user-marketing-rules/application/notify-download-app-message-viewed-use-case";

@Injectable()
export class DownloadAppModalViewModel {
    constructor(
        private notifyDownloadAppMessageViewedUseCase: NotifyDownloadAppMessageViewedUseCase
    ) {}

    notifyDownloadAppModalClosed() {
        this.notifyDownloadAppMessageViewedUseCase.execute().subscribe();
    }
}